import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91f87816"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "contentLeft",
  id: "contentLeft"
}
const _hoisted_2 = {
  class: "article",
  style: {"text-align":"left"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { onMounted, ref, reactive, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { KeySortResults } from "@/api/apitypes/response/ArticleResponse";
import {
  KeySearchRequest,
  initKeySearchRequest,
} from "@/api/apitypes/request/ArticleSearchRequest";
import { keySearchArticles } from "@/api/functions/search";
import { Search } from "@element-plus/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchContent',
  setup(__props) {

const state = reactive({
  articlesSort: [] as KeySortResults[],
  totalCount: 0,
});

const route = useRoute();

const router = useRouter();

const searchInput = ref(route.query.key);

const keySearchRequest: KeySearchRequest = initKeySearchRequest();

const searchRouter = () => {
  router.replace({
    path: "/search",
    query: { key: searchInput.value },
  });
};

const searchHandle = async () => {
  keySearchRequest.key = searchInput.value as string;
  await keySearchArticles(keySearchRequest).then((res) => {
    state.articlesSort = res.data.articlesSort;
    state.totalCount = res.data.totalCount;
  });
};

onMounted(async () => {
  searchHandle();
  var scrollDom = document.getElementById("contentLeft") as HTMLElement;
  scrollDom.scrollIntoView();
});

watch(route, () => {
  searchHandle();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _createVNode(_component_el_input, {
        placeholder: "搜搜看吧",
        modelValue: searchInput.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event))
      }, {
        append: _withCtx(() => [
          _createVNode(_component_el_button, {
            icon: _unref(Search),
            onClick: searchRouter
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("h4", null, _toDisplayString(state.totalCount) + " 条结果", 1),
      _createVNode(_component_el_divider),
      _createVNode(_component_el_timeline, { style: {"padding-left":"10px"} }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.articlesSort, (articleSort) => {
            return (_openBlock(), _createBlock(_component_el_timeline_item, {
              timestamp: articleSort.year.toString(),
              placement: "top"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleSort.articles, (article) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createVNode(_component_el_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, [
                          _createVNode(_component_router_link, {
                            class: "article-title",
                            to: {
                    name: 'detail',
                    params: { theme: article.theme },
                  }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(article.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("p", null, _toDisplayString(article.createTime), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _hoisted_3
                  ]))
                }), 256))
              ]),
              _: 2
            }, 1032, ["timestamp"]))
          }), 256))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})